<template>
  <ul class="nav nav-tabs">
    <li :class="{ active: isActiveTab('VenueGeneralSettings') }">
      <router-link
        :to="{ name: 'VenueGeneralSettings', params: { id: venueId } }"
        >{{ $label("venue.base_data_tab", "General") }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('VenueImages') }">
      <router-link :to="{ name: 'VenueImages', params: { id: venueId } }">{{
        $label("venue.images_settings_tab", "Images")
      }}</router-link>
    </li>

    <li
      :class="{
        active:
          isActiveTab('VenuePrices') ||
          isActiveTab('VenuePriceDetails') ||
          isActiveTab('NewVenuePrice')
      }"
    >
      <router-link :to="{ name: 'VenuePrices', params: { id: venueId } }">
        {{ $label("venue.price_settings_tab", "Price settings") }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["venueId"],

  methods: {
    isActiveTab(tab) {
      return this.$route.name == tab;
    }
  }
};
</script>
